import { render, staticRenderFns } from "./QLeadAllocationTable.vue?vue&type=template&id=d59e8e64&"
import script from "./QLeadAllocationTable.vue?vue&type=script&lang=js&"
export * from "./QLeadAllocationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports